<template>
    <filexbox :obj="this.form" />
</template>

<script>
import filexbox from '../../../formright/files/filesblock'

export default{
    props: ['obj'],
    components: {
        filexbox
    },
    data(){
        return{
            form: {}
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        getdata(){
            this.form = this.obj
        }
    }
}
</script>